import { INITIAL_STATE } from 'reducers/storylet/constants';
import { IStoryletState } from 'types/storylet';

export default function clearCache(state: IStoryletState) {
  // We need to preserve storylet phase so that usable items don't become unusable
  // because of an outfit change.
  const { phase } = state;
  return {
    ...INITIAL_STATE,
    phase,
  };
}